import { render, staticRenderFns } from "./FacilityCIS.vue?vue&type=template&id=2452a885&scoped=true&"
import script from "./FacilityCIS.vue?vue&type=script&lang=js&"
export * from "./FacilityCIS.vue?vue&type=script&lang=js&"
import style0 from "./FacilityCIS.vue?vue&type=style&index=0&id=2452a885&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2452a885",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
